import base64 from 'base-64';
import numeral from 'numeral';
import moment from 'moment';
import 'moment/locale/vi';
import _ from 'lodash';
import emailValidator from 'email-validator';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

moment.locale('vi');

export default class Utils {
  static isEmailValid (email) {
    return emailValidator.validate(email);
  }

  static isPhoneValid (phone) {
    const phoneUtil = PhoneNumberUtil.getInstance();
    var phoneValid = false;
    try {
      const phoneNumber = phoneUtil.parse(phone, 'VN');
      phoneValid = phoneUtil.isValidNumber(phoneNumber);
    } catch (error) {
      phoneValid = false;
    }
    return phoneValid;
  }

  static createHeaders () {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    };
    return headers;
  }

  static createBasicAuthHeaders (credential) {
    if (_.isEmpty(credential)) {
      return Utils.createHeaders();
    }

    const {username, password} = credential;
    if (_.isEmpty(username) || _.isEmpty(password)) {
      return Utils.createHeaders();
    }

    const credentialString = `${credential.username}:${credential.password}`;
    const headers = {
      'Authorization': 'Basic ' + base64.encode(credentialString),
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    };
    return headers;
  }

  static createBodyParams (params) {
    return Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
  }

  static priceToString (price, currency) {
    if (typeof price !== 'number' && typeof price !== 'string') {
      return price;
    }

    if (!currency) {
      currency = 'đ';
    }

    if (typeof price === 'string') {
      if (price.indexOf(currency) !== -1) {
        return price;
      }
      return price + currency;
    }

    return numeral(price).format('0,0') + currency;
  }

  /**
   * parse success message from network response
   */
  static parseSuccessMessage (response, defaultMessage) {
    if (response && response.response) {
      return response.response.message;
    }
    return defaultMessage;
  }

  /**
   * parse error message from network response
   */
  static parseErrorMessage (response, error, defaultMessage) {
    if (error) {
      return error.message;
    }
    if (response && response.error) {
      return response.error.message;
    }
    return defaultMessage;
  }

  static dateToString = (date, format = 'Do MMMM YYYY, h:mm:ss a') => {
    return moment(date).format(format);
  };
}



// WEBPACK FOOTER //
// ./src/utils/Utils.js